import {h, Fragment} from "preact"
import { ResultsV2 as Results } from '../'

/**
 * 
 * This page acts as a wrapper for <Results />
 * It's probably better at some point to replace the component injection from the configuration file.
 * However, in the original version both <Category> and <Serp> components were independent, although we could not find
 * any differences in the code except for a few classes.
 * For compatibility reasons, and in case in the future both pages need to behave differently or include
 * different markup, we're keeping this page as a wrapper
 * 
 */
export default function Serp() {
    return <Results />
}
